<template>
  <span style="display: inline-block">
    <v-btn class="mx-1" color="primary" @click="handleShowManagePage()">Manage Bot Origin</v-btn>
    <v-dialog v-model="showManagePage" scrollable persistent max-width="1000">
      <v-card>
        <div v-if="loading" class="text-xs-center my-4">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <template v-else>
          <div class="text-xs-right">
            <v-btn fab flat small @click="showManagePage = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-divider></v-divider>
          <v-card-text max-height="600">
            <v-layout wrap class="font-weight-bold">
              <v-flex xs5 class="py-2">
                Name
              </v-flex>
              <v-flex xs4 class="py-2">
                Origin
              </v-flex>
              <v-flex xs1 class="py-2">
                Status
              </v-flex>
              <v-flex xs2 class="py-2 text-xs-center">
                Action
              </v-flex>
            </v-layout>
            <v-divider />
            <template v-for="(bot, index) in filterBots">
              <div :key="bot.botorigin">
                <v-layout wrap>
                  <v-flex xs5 class="py-3">
                    {{ bot.botname }}
                  </v-flex>
                  <v-flex xs4 class="py-3">
                    {{ bot.botorigin }}
                  </v-flex>
                  <v-flex xs1 class="py-3">
                    {{ bot.botstatus ? 'Active' : 'Inactive' }}
                  </v-flex>
                  <v-flex xs2 class="text-xs-center">
                    <v-btn
                      fab
                      small
                      flat
                      @click="
                        currentPage = bot
                        showEditPage = true
                      "
                      ><v-icon>edit</v-icon></v-btn
                    >
                    <v-btn fab small flat @click="deletebotorigin(bot)"
                      ><v-icon>delete</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </div>
              <v-divider :key="'divider_' + bot.botorigin" v-if="index != bots.length - 1" />
            </template>
            <div class="text-xs-center">
              <v-pagination v-model="page" :length="pages"></v-pagination>
            </div>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="showAddPage = true" color="primary" depressed>
              <v-icon>add</v-icon> Add Origin
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
    <add-bot v-model="showAddPage" :bots="bots" @saveBot="addBot"></add-bot>
    <template v-if="currentPage">
      <add-bot
        :key="timestamp"
        v-model="showEditPage"
        :page="currentPage"
        :bots="bots"
        @onCancel="currentPage = null"
        @saveBot="editBot"
      ></add-bot>
    </template>
  </span>
</template>

<script>
import AddBot from './AddBot'
import api from '@/api'
import moment from 'moment'
export default {
  components: {
    AddBot
  },
  data() {
    return {
      showManagePage: false,
      showAddPage: false,
      showEditPage: false,
      bots: [],
      currentPage: null,
      timestamp: moment().format('x'),
      rowsPerPage: 10,
      page: 1,
      pages: 0,
      loading: false
    }
  },
  async mounted() {},
  computed: {
    filterBots() {
      let bots = []
      if (this.rowsPerPage > 0) {
        bots = this.bots.slice((this.page - 1) * this.rowsPerPage, this.page * this.rowsPerPage)
      }
      return bots
    }
  },
  methods: {
    async handleShowManagePage() {
      this.loading = true
      this.showManagePage = true
      await this.getallbotorigins()
      this.loading = false
    },
    editBot(payload) {
      var botIndex = this.bots.findIndex(el => {
        return el.botorigin == payload.botorigin
      })
      if (botIndex != -1) {
        this.$set(this.bots, botIndex, payload)
      }
      this.currentPage = null
      this.timestamp = moment().format('x')
    },
    addBot(payload) {
      this.bots.push(payload)
    },
    async getallbotorigins() {
      var response = await api.getallbotorigins()
      this.bots = response.data
      this.pages = Math.ceil(response.data.length / this.rowsPerPage)
    },
    async deletebotorigin(bot) {
      var result = await this.$swal({
        title: 'Do you want to delete this?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        var response = await api.deletebotorigin({
          botorigin: bot.botorigin
        })

        if (response.responsecode == 200) {
          this.bots = this.bots.filter(el => {
            return el.botorigin != bot.botorigin
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/BotManage.vue